import React from "react";

const NoHouses = () => {
  return (
    <div className="jumbotron justify-content-center">
      <h3 className="h3 text-center text-primary">No Houses</h3>
    </div>
  );
};

export default NoHouses;
